import React, { useEffect, useState } from "react";
import { Table , Checkbox ,  Tooltip,} from "antd";
// import Api from "../../../../../services/ServiceApi";
import Cookies from "js-cookie";
import moment from "moment";
import { VList } from "virtuallist-antd";


const BusTable = ({ tabStatus, setBookedData, setBookedAmount, busesData , originalData , setoriginal_data , setcountJob }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [busData, setBusData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [checkboxAll, setcheckboxAll] = useState(false);
  // const [addBooking, setaddBooking] = useState([]);
  let data_bus = busesData;

  const [filteredInfo, setFilteredInfo] = useState([]);
  const [sortedInfo, setSortedInfo] = useState([]);



  useEffect(() => {
        setBusData([]);
        setBusData(busesData);
        data_bus.map((item, index) => {
          if(item.bus_id == 10){
          }
          if(item.fw === true){
            item.externalFW = item.fW_advertise_list_id
          }
          if(item.hw === true){
            item.externalHW = item.hW_advertise_list_id
          }
          if(item.qw === true){
            item.externalQW = item.qW_advertise_list_id
          }
          if(item.external_ad_start !== "" && item.external_ad_start !== null){
            item.externalStartDate = moment(item.external_ad_start).format('DD/MM/YYYY')
          }
          if(item.external_ad_end !== "" && item.external_ad_end !== null){
            item.externalStartDate = moment(item.external_ad_end).format('DD/MM/YYYY')
          }
          if(item.hg === true){
            item.hangar = item.hG_advertise_list_id
          }
          if(item.lcd === true){
            item.LCD = item.lcD_advertise_list_id
          }
          if(item.internal_ad_start !== "" && item.internal_ad_start !== null){
            item.internalStartDate = moment(item.internal_ad_start).format('DD/MM/YYYY')
          }
          if(item.internal_ad_end !== "" && item.internal_ad_end !== null){
            // item.internalExpiredDate = item.internal_ad_end
            item.internalExpiredDate = moment(item.internal_ad_end).format('DD/MM/YYYY')
          }
          if(item["2D"] === true){
            //item.two_d = 1
            item.two_d = item["2D_advertise_list_id"]
          }
          if(item["3D"] === true){
            // item.three_d = 1
            item.three_d = item["3D_advertise_list_id"]
          }
          if(item["led"] === true){
            // item.lightning = 1
            item.lightning = item["leD_advertise_list_id"]
          }
          if(item["reflective_film"] === true){
            // item.reflectiveFilms = 1
            item.reflectiveFilms = item["reflective_film_advertise_list_id"]
          }
        })
        setFilteredData(data_bus);


  }, [busesData]);

  const changeBusData  = async () => {
    await setFilteredData([]);
    // setBookedData กรณีเปลี่ยน tab และยังไม่ได้ select booked bus เพิ่ม 
    if (tabStatus === "All") {
      console.log("1");
      // console.log(filteredData);
      setFilteredData(busData);
      setBookedData(selectedRows);
    } else if (tabStatus === "Not Available") {
      console.log("3");
      setFilteredData([]);
      // console.log(filteredData);
      var dataNotAvailable = busData.filter((i) => i.status_avaliable === "NOT AVAILABLE") ; 
      // console.log(dataNotAvailable);
      setFilteredData(dataNotAvailable);
      setBookedData(selectedRows.filter((i) => i.status_avaliable === "NOT AVAILABLE"));
   
      // console.log(filteredData);
    } else if (tabStatus === "Available") {
      console.log("2");
      setFilteredData([]);
      // console.log(filteredData);
        var dataAvailable = busData.filter((i) => i.status_avaliable === "AVAILABLE") ; 
        // console.log(dataAvailable);
        setFilteredData(dataAvailable);
        setBookedData(selectedRows.filter((i) => i.status_avaliable === "AVAILABLE"));
    }
  }

  useEffect( () => {
 
    changeBusData();
   
  }, [tabStatus]);

  const  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, filters, sorter);
    changeBusData();
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const filterList = (data, value, title) => {
    // console.log(data);
    // console.log(title.toString().toLowerCase().includes("date"));
    var filter_list = [];
    for (let i = 0 ; i < data.length ; i++){
      if(data[i][value] != null){
        if (Date.parse(data[i][value]) && title.toString().toLowerCase().includes("date")) {
          //value is  a date
          filter_list.push({
            text: moment(data[i][value]).format("DD/MM/YYYY"),
            value: data[i][value],
          })
        }else {
          filter_list.push({
            text: data[i][value],
            value: data[i][value],
          })
        } 
      }
    }
      var unique = filter_list.reduce((unique, o) => {
        if(!unique.some(obj => obj.text === o.text )) {
          unique.push(o);
        }
        return unique;
    },[]);
    // console.log(unique);
    return unique;
  }



  const columns = [
    {
      title: <Checkbox onChange={() => CheckboxAssign("all")}></Checkbox>,
      dataIndex: "",
      width: 40,
      key: "",
      render: (item) => (
        <Checkbox
          onChange={() => CheckboxAssign(item)}
          checked={item["status_checkbox"]}
        ></Checkbox>
      ),

      // sorter: () => null,
    },

    // Bus
    {
      title: <span>Bus</span>,
      align: "center" , 
      children: [
        {
          title: "Plate No.",
          dataIndex: "license_plate",
          width: 120,
          key: "license_plate",
          render: (license_plate, record) => {
            // console.log('return record', record)
            return (
              <>
     
              <a href="bus_detail" className="c-blue text-underline" onClick={() => {
                Cookies.set("activeTab", 0, { expires: 1 })
                Cookies.set('selected_bus_id', record.bus_id)
              }}>
                {license_plate}
              </a>
              </>
            );
          },
          sorter: (a, b) => {
            if( (a.license_plate !== undefined && b.license_plate !== undefined) &&  (a.license_plate !== null && b.license_plate !== null) ){ 
                    return   a.license_plate.localeCompare(b.license_plate)
            }
         },
      
        },
        {
          title: "Line No.",
          width: 100,
          dataIndex: "bus_line_name",
          key: "bus_line_name",
          sorter: (a, b) => {
            if( (a.bus_line_name !== undefined && b.bus_line_name !== undefined) &&  (a.bus_line_name !== null && b.bus_line_name !== null) ){ 
                    return   a.bus_line_name.localeCompare(b.bus_line_name)
            }
         }
        },
        {
          title: "Area",
          width: 100,
          dataIndex: "area_name",
          key: "area_name",
          sorter: (a, b) => {
            if( (a.area_name !== undefined && b.area_name !== undefined) &&  (a.area_name !== null && b.area_name !== null) ){ 
                    return   a.area_name.localeCompare(b.area_name)
            }
         }
        },
        {
          title: "Division",
          width: 100,
          dataIndex: "division_name",
          key: "division_name",
          sorter: (a, b) => {
            if( (a.division_name !== undefined && b.division_name !== undefined) &&  (a.division_name !== null && b.division_name !== null) ){ 
                    return   a.division_name - b.division_name
            }
         }
        },
        {
          title: "Garage",
          width: 100,
          dataIndex: "garage_name",
          key: "garage_name",
          sorter: (a, b) => {
            if( (a.garage_name !== undefined && b.garage_name !== undefined) &&  (a.garage_name !== null && b.garage_name !== null) ){ 
                    return   a.garage_name.localeCompare(b.garage_name)
            }
         }
        },
        {
          title: "Bus No.",
          width: 100,
          dataIndex: "bus_no",
          key: "bus_no",
          sorter: (a, b) => {
            if( (a.bus_no !== undefined && b.bus_no !== undefined) &&  (a.bus_no !== null && b.bus_no !== null) ){ 
                    return   a.bus_no - b.bus_no
            }
         }
        },
        {
          title: "Model",
          width: 100,
          dataIndex: "model_name",
          key: "model_name",
          sorter: (a, b) => {
            if( (a.model_name !== undefined && b.model_name !== undefined) &&  (a.model_name !== null && b.model_name !== null) ){ 
                    return   a.model_name.localeCompare(b.model_name)
            }
         }
        },
        {
          title: "Bus Group",
          dataIndex: "bus_group_name",
          width: 100,
          key: "bus_group_name",
          sorter: (a, b) => {
            if( (a.bus_group_name !== undefined && b.bus_group_name !== undefined) &&  (a.bus_group_name !== null && b.bus_group_name !== null) ){ 
                    return   a.bus_group_name.localeCompare(b.bus_group_name)
            }
         }
        },
        {
          title: "Bus Type",
          width: 100,
          dataIndex: "bus_type_name",
          key: "bus_type_name",
          sorter: (a, b) => {
            if( (a.bus_type_name !== undefined && b.bus_type_name !== undefined) &&  (a.bus_type_name !== null && b.bus_type_name !== null) ){ 
                    return   a.bus_type_name.localeCompare(b.bus_type_name)
            }
         }
        },
        {
          title: "Media ID",
          width: 100,
          dataIndex: "media_id",
          key: "media_id",
          sorter: (a, b) => {
            if( (a.media_id !== undefined && b.media_id !== undefined) &&  (a.media_id !== null && b.media_id !== null) ){ 
                    return   a.media_id.localeCompare(b.media_id)
            }
         }
        },
        {
          title: "Bus Contact",
          dataIndex: "has_contract",
          width: 120,
          key: "has_contract",
          render: (hasContract) =>
            hasContract ? (
              <span> Yes</span>
            ) : (
              <span style={{ color: "#e04b4d" }}> Expired</span>
            ),
          sorter: (a, b) => {
              if( (a.has_contract !== undefined && b.has_contract !== undefined) &&  (a.has_contract !== null && b.has_contract !== null) ){ 
                      return   a.has_contract.localeCompare(b.has_contract)
              }
           }
        },
        {
          title: "Bus Contact Expire Date",
          width: 180,
          // dataIndex: "contact_expire_date",
          key: "contact_expire_date",
          render: (item) =>  { return <div>
               {/* {console.log(moment(item.contact_expire_date).format(dateFormat))} */}
              {item.contact_expire_date ? moment(item.contact_expire_date).format(dateFormat): "-"}
            </div>
          },
          sorter: (a, b) => {
            if( (a.contact_expire_date !== undefined && b.contact_expire_date !== undefined) &&  (a.contact_expire_date !== null && b.contact_expire_date !== null) ){ 
                    return   a.contact_expire_date.localeCompare(b.contact_expire_date)
            }
         }
        },
      ],
    },
    // Advertisement area ?/
    {
      title: "Advertisement area",
      children: [
        {
          title: "External-FW",
          dataIndex: "fW_advertise_list_id",
          width: 120,
          key: "fW_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.fW_advertise_list_id !== undefined && b.fW_advertise_list_id !== undefined) &&  (a.fW_advertise_list_id !== null && b.fW_advertise_list_id !== null) ){ 
                    return   a.fW_advertise_list_id.localeCompare(b.fW_advertise_list_id)
            }
         }
        },
        {
          title: "External-HW",
          width: 120,
          dataIndex: "hW_advertise_list_id",
          key: "hW_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.hW_advertise_list_id !== undefined && b.hW_advertise_list_id !== undefined) &&  (a.hW_advertise_list_id !== null && b.hW_advertise_list_id !== null) ){ 
                    return   a.hW_advertise_list_id.localeCompare(b.hW_advertise_list_id)
            }
         }
        },
        {
          title: "External-QW",
          width: 120,
          dataIndex: "qW_advertise_list_id",
          key: "qW_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.qW_advertise_list_id !== undefined && b.qW_advertise_list_id !== undefined) &&  (a.qW_advertise_list_id !== null && b.qW_advertise_list_id !== null) ){ 
                    return   a.qW_advertise_list_id.localeCompare(b.qW_advertise_list_id)
            }
         }
        },
        {
          title: "Internal In Bus",
          width: 140,
          dataIndex: "iB_advertise_list_id",
          key: "iB_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.iB_advertise_list_id !== undefined && b.iB_advertise_list_id !== undefined) &&  (a.iB_advertise_list_id !== null && b.iB_advertise_list_id !== null) ){ 
                    return   a.iB_advertise_list_id.localeCompare(b.iB_advertise_list_id)
            }
         }
        },
        {
          title: "Internal Hangar",
          width: 140,
          dataIndex: "hG_advertise_list_id",
          key: "hG_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.hG_advertise_list_id !== undefined && b.hG_advertise_list_id !== undefined) &&  (a.hG_advertise_list_id !== null && b.hG_advertise_list_id !== null) ){ 
                    return   a.hG_advertise_list_id.localeCompare(b.hG_advertise_list_id)
            }
         }
        },
        {
          title: "Internal LCD",
          width: 140,
          dataIndex: "lcD_advertise_list_id",
          key: "lcD_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.lcD_advertise_list_id !== undefined && b.lcD_advertise_list_id !== undefined) &&  (a.lcD_advertise_list_id !== null && b.lcD_advertise_list_id !== null) ){ 
                    return   a.lcD_advertise_list_id.localeCompare(b.lcD_advertise_list_id)
            }
         }
        },
        {
          title: "2D",
          width: 100,
          dataIndex: "2D_advertise_list_id",
          key: "2D_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            var param = "2D_advertise_list_id"
            if( (a.param !== undefined && b.param !== undefined) &&  (a.param !== null && b.param !== null) ){ 
                    return   a.param.localeCompare(b.param)
            }
         }
        },
        {
          title: "3D",
          width: 100,
          dataIndex: "3D_advertise_list_id",
          key: "3D_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            var param = "3D_advertise_list_id"
            if( (a.param !== undefined && b.param !== undefined) &&  (a.param !== null && b.param !== null) ){ 
                    return   a.param.localeCompare(b.param)
            }
         }
        },
        {
          title: "Current Uninstall",
          dataIndex: "current_uninstall_flag",
          width: 140,
          align: "center",
          key: "current_uninstall_flag",
          render: (item) => {
            {
              return item === null || item === 0 || item === undefined
                ?  <span className="badge badge-pill badge-primary font-thai-b font14">
                      Not Uninstalled
                   </span>
                : <span className="badge badge-pill badge-success font-thai-b font14">
                      Uninstalled
                  </span>;
            }
          },
          sorter: (a, b) => 
          // {
            // if( (a.current_uninstall_flag !== undefined && b.current_uninstall_flag !== undefined) &&  (a.current_uninstall_flag !== null && b.current_uninstall_flag !== null) ){ 
            //         return   a.current_uninstall_flag - b.current_uninstall_flag
            // }
            (a.current_uninstall_flag === null || a.current_uninstall_flag  === undefined ? 0 : a.current_uninstall_flag) -  
            (b.current_uninstall_flag === null || b.current_uninstall_flag  === undefined ? 0 : b.current_uninstall_flag)
        //  }
        },
        {
          title: "Current Install",
          dataIndex: "current_install_flag",
          width: 140,
          align: "center",
          key: "current_install_flag",
          render: (item) => {
            {
                if(item === null || item === 0 || item === undefined) {
                 return   <span className="badge badge-pill badge-primary font-thai-b font14">
                        Not Installed
                   </span>
                } else {
                 return  <span className="badge badge-pill badge-success font-thai-b font14">
                       Installed
                  </span>
                }
              
            }
          },
          sorter: (a, b) => 
            // if( (a.current_install_flag !== undefined && b.current_install_flag !== undefined) &&  (a.current_install_flag !== null && b.current_install_flag !== null) ){ 
            //         return   a.current_install_flag - b.current_install_flag
            // } 
               (a.current_install_flag === null || a.current_install_flag  === undefined ? 0 : a.current_install_flag) -  
               (b.current_install_flag === null || b.current_install_flag  === undefined ? 0 : b.current_install_flag)
         
        },
      ],
    },
    // Internal date
    {
      title: "Internal Date",
      children: [
        {
          title: "Internal Ads",
          width: 140,
          dataIndex: "internal_advertise_name",
          key: "internal_advertise_name",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.internal_advertise_name !== undefined && b.internal_advertise_name !== undefined) &&  (a.internal_advertise_name !== null && b.internal_advertise_name !== null) ){ 
                    return   a.internal_advertise_name.localeCompare(b.internal_advertise_name)
            }
         }
         ,
         filters: filterList(filteredData,"internal_advertise_name", "Internal Ads" ),
         filteredValue: filteredInfo.internal_advertise_name || null,
         onFilter: (value, record) => { 
            if(record.internal_advertise_name != null){
              return record.internal_advertise_name.includes(value)
            }          
          },
        //  sortOrder: sortedInfo.columnKey === 'internal_advertise_name' && sortedInfo.order,
        },
        {
          title: "Start Date",
          width: 140,
          dataIndex: "internal_ad_start",
          key: "internal_ad_start",
          render: (item) => {
            {
              return item === null
                ? "-"
                : moment(item).format("DD/MM/YYYY");
            }
          },
          sorter: (a, b) => {
            if( (a.internal_ad_start !== undefined && b.internal_ad_start !== undefined) &&  (a.internal_ad_start !== null && b.internal_ad_start !== null) ){ 
                    return   a.internal_ad_start.localeCompare(b.internal_ad_start)
            }
         }
         ,
         filters: filterList(filteredData,"internal_ad_start",  "Start Date" ),
         filteredValue: filteredInfo.internal_ad_start || null,
         onFilter: (value, record) => {
           if(record.internal_ad_start != null){
            return record.internal_ad_start.includes(value)
           }  
         },
        //  sortOrder: sortedInfo.columnKey === 'internal_ad_start' && sortedInfo.order,
        },
        {
          title: "Expired Date",
          width: 140,
          dataIndex: "internal_ad_end",
          key: "internal_ad_end",
          render: (item) => {
            {
              return item === null
                ? "-"
                : moment(item).format("DD/MM/YYYY");
            }
          },
          sorter: (a, b) => {
            if( (a.internal_ad_end !== undefined && b.internal_ad_end !== undefined) &&  (a.internal_ad_end !== null && b.internal_ad_end !== null) ){ 
                    return   a.internal_ad_end.localeCompare(b.internal_ad_end)
            }
         }
         ,
         filters: filterList(filteredData,"internal_ad_end", "Expired Date" ),
         filteredValue: filteredInfo.internal_ad_end || null,
         onFilter: (value, record) => {
           if(record.internal_ad_end != null){
            return record.internal_ad_end.includes(value)
           }  
         },
        //  sortOrder: sortedInfo.columnKey === 'internal_ad_end' && sortedInfo.order,
        },
        {
          title: "Internal Lock Type",
          dataIndex: "internal_lock_type",
          width: 140,
          align: "center",
          key: "internal_lock_type",
          render: (item) => {
            {
              return item === null
              ? "-"
              : item;
            }
          },
          sorter: (a, b) => 
          (a.internal_lock_type === null || a.internal_lock_type  === undefined ? "": a.internal_lock_type).localeCompare 
          (b.internal_lock_type === null || b.internal_lock_type  === undefined ? "" : b.internal_lock_type)        
        },
      ],
    },
    // External date
    {
      title: "External Date",
      children: [
        {
          title: "External Ads",
          dataIndex: "external_advertise_name",
          width: 140,
          key: "external_advertise_name",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.external_advertise_name !== undefined && b.external_advertise_name !== undefined) &&  (a.external_advertise_name !== null && b.external_advertise_name !== null) ){ 
                    return   a.external_advertise_name.localeCompare(b.external_advertise_name)
            }
         }
         ,
         filters: filterList(filteredData,"external_advertise_name", "External Ads" ),
         filteredValue: filteredInfo.external_advertise_name || null,
         onFilter: (value, record) => { 
            if(record.external_advertise_name != null){
              return record.external_advertise_name.includes(value)
            }          
          },
        //  sortOrder: sortedInfo.columnKey === 'external_advertise_name' && sortedInfo.order,
        },
        {
          title: "Start Date",
          width: 140,
          dataIndex: "external_ad_start",
          key: "external_ad_start",
          render: (item) => {
            {
              return item === null
                ? "-"
                : moment(item).format("DD/MM/YYYY");
            }
          },
          sorter: (a, b) => {
            if( (a.external_ad_start !== undefined && b.external_ad_start !== undefined) &&  (a.external_ad_start !== null && b.external_ad_start !== null) ){ 
                    return   a.external_ad_start.localeCompare(b.external_ad_start)
            }
         }
         ,
         filters: filterList(filteredData,"external_ad_start", "Start Date" ),
         filteredValue: filteredInfo.external_ad_start || null,
         onFilter: (value, record) => {
           if(record.external_ad_start != null){
            return record.external_ad_start.includes(value)
           }  
         },
        //  sortOrder: sortedInfo.columnKey === 'external_ad_start' && sortedInfo.order,
        },
        {
          title: "Expired Date",
          width: 140,
          dataIndex: "external_ad_end",
          key: "external_ad_end",
          render: (item) => {
            {
              return item === null
                ? "-"
                : moment(item).format("DD/MM/YYYY");
            }
          },
          sorter: (a, b) => {
            if( (a.external_ad_end !== undefined && b.external_ad_end !== undefined) &&  (a.external_ad_end !== null && b.external_ad_end !== null) ){ 
                    return   a.external_ad_end.localeCompare(b.external_ad_end)
            }
         }
         ,
         filters: filterList(filteredData,"external_ad_end", "End Date" ),
         filteredValue: filteredInfo.external_ad_end || null,
         onFilter: (value, record) => {
           if(record.external_ad_end != null){
            return record.external_ad_end.includes(value)
           }  
         },
        //  sortOrder: sortedInfo.columnKey === 'external_ad_end' && sortedInfo.order,
        },
        {
          title: "External Lock Type",
          dataIndex: "external_lock_type",
          width: 140,
          align: "center",
          key: "external_lock_type",
          render: (item) => {
            {
              return item === null || item === undefined
              ? "-"
              : item;
            }
          },
          sorter: (a, b) => 
               (a.external_lock_type === null || a.external_lock_type  === undefined ? "": a.external_lock_type).localeCompare 
               (b.external_lock_type === null || b.external_lock_type  === undefined ? "" : b.external_lock_type)       
        },
      ],
    },
    // Technique with unique render condition
    {
      title: "Technique",
      children: [
        {
          title: "Lightning",
          width: 140,
          dataIndex: "leD_advertise_list_id",
          key: "leD_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.leD_advertise_list_id !== undefined && b.leD_advertise_list_id !== undefined) &&  (a.leD_advertise_list_id !== null && b.leD_advertise_list_id !== null) ){ 
                    return   a.leD_advertise_list_id.localeCompare(b.leD_advertise_list_id)
            }
         }
         ,
         filters: filterList(filteredData,"leD_advertise_list_id", "Lightning" ),
         filteredValue: filteredInfo.leD_advertise_list_id || null,
         onFilter: (value, record) => {
           if(record.leD_advertise_list_id != null){
            return record.leD_advertise_list_id.includes(value)
           }  
         },
        //  sortOrder: sortedInfo.columnKey === 'leD_advertise_list_id' && sortedInfo.order,
        },
        {
          title: "Reflective Films",
          width: 160,
          dataIndex: "reflective_film_advertise_list_id",
          key: "reflective_film_advertise_list_id",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.reflective_film_advertise_list_id !== undefined && b.reflective_film_advertise_list_id !== undefined) &&  (a.reflective_film_advertise_list_id !== null && b.reflective_film_advertise_list_id !== null) ){ 
                    return   a.reflective_film_advertise_list_id.localeCompare(b.reflective_film_advertise_list_id)
            }
         }
         ,
         filters: filterList(filteredData,"reflective_film_advertise_list_id", "Reflective Films" ),
         filteredValue: filteredInfo.reflective_film_advertise_list_id || null,
         onFilter: (value, record) => {
           if(record.reflective_film_advertise_list_id != null){
            return record.reflective_film_advertise_list_id.includes(value)
           }  
         },
        //  sortOrder: sortedInfo.columnKey === 'reflective_film_advertise_list_id' && sortedInfo.order,
        },
      ],
    },
    {
      title: "Remark",
      children: [
        {
          title: "remark",
          width: 100,
          align: "center" , 
          dataIndex: "remark",
          key: "remark",
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.remark !== undefined && b.remark !== undefined) &&  (a.remark !== null && b.remark !== null) ){ 
                    return   a.remark.localeCompare(b.remark)
            }
         }
        },
      ],
    },
    {
      title: "Prev Advertise",
      children: [
        {
          title: "Next Booking",
          dataIndex: "next_booking_advertise_list",
          key: "next_booking_advertise_list",
          width: 140,
          ellipsis: {
            showTitle: false,
          },
          render: (item) => {
            {
              return item === null || item === ""
                ? "-"
                : 
                <Tooltip
                placement="topLeft"
                title={item}
              >
                {item}
              </Tooltip>
            }
          },
          sorter: (a, b) => {
            if( (a.next_booking_advertise_list !== undefined && b.next_booking_advertise_list !== undefined) &&  (a.next_booking_advertise_list !== null && b.next_booking_advertise_list !== null) ){ 
                    return   a.next_booking_advertise_list.localeCompare(b.next_booking_advertise_list)
            }
         }
         ,
         filters: filterList(filteredData,"next_booking_advertise_list", "Next Booking" ),
         filteredValue: filteredInfo.next_booking_advertise_list || null,
         onFilter: (value, record) => {
           if(record.next_booking_advertise_list != null){
            return record.next_booking_advertise_list.includes(value)
           }  
         },
        },
        {
          title: "Prev Internal Ads",
          dataIndex: "prev_internal_ad_name",
          key: "prev_internal_ad_name",
          width: 150,
          render: (item) => {
            {
              return item === null || item === ""
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.prev_internal_ad_name !== undefined && b.prev_internal_ad_name !== undefined) &&  (a.prev_internal_ad_name !== null && b.prev_internal_ad_name !== null) ){ 
                    return   a.prev_internal_ad_name.localeCompare(b.prev_internal_ad_name)
            }
         }
        },
        {
          title: "Prev External Ads",
          dataIndex: "prev_external_ad_name",
          key: "prev_external_ad_name",
          width: 150,
          render: (item) => {
            {
              return item === null
                ? "-"
                : item;
            }
          },
          sorter: (a, b) => {
            if( (a.prev_external_ad_name !== undefined && b.prev_external_ad_name !== undefined) &&  (a.prev_external_ad_name !== null && b.prev_external_ad_name !== null) ){ 
                    return   a.prev_external_ad_name.localeCompare(b.prev_external_ad_name)
            }
         }
        },
      ],
    },
    {
      title: "Book Status",
      dataIndex: "sub_status",
      width: 120,
      key: "sub_status",
      render: (sub_status) => {
        if(sub_status){
            if (sub_status.toLowerCase() == "booked") {
              return <span style={{ color: "#a2e059" }}>{sub_status}</span>;
            } else {
              return <span style={{ color: "#e04b4d" }}>{sub_status}</span>;
          }
        }
      },
      sorter: (a, b) => {
        if( (a.status_avaliable !== undefined && b.status_avaliable !== undefined) &&  (a.status_avaliable !== null && b.status_avaliable !== null) ){ 
                return   a.status_avaliable - b.status_avaliable
        }
     }
    },
    {
      title: "Status",
      dataIndex: "status_avaliable",
      width: 100,
      key: "status_avaliable",
      fixed: "right",
      render: (status, record) => {
          if (status === "AVAILABLE") {
            return <span style={{ color: "#a2e059" }}> Available</span>;
          } else {
            return <span style={{ color: "#e04b4d" }}> Not Available</span>;

        }
      },
      sorter: (a, b) => {
        if( (a.status_avaliable !== undefined && b.status_avaliable !== undefined) &&  (a.status_avaliable !== null && b.status_avaliable !== null) ){ 
                return   a.status_avaliable - b.status_avaliable
        }
     }
    },
  ];
  const dateFormat = "DD/MM/YYYY";



  const CheckboxAssign = (value) => {
    if (value === "all") {
      if (checkboxAll === false) {
        for (let i = 0; i < originalData.length; i++) {
          originalData[i]["status_checkbox"] = true
        }
        for (let i = 0; i < filteredData.length; i++) {
          filteredData[i]["status_checkbox"] = true
        }
        const result = originalData.filter(data => data.status_checkbox === true);
        setBookedAmount(result);
        setFilteredData([...filteredData]);
        setoriginal_data(originalData);
        setcheckboxAll(true);
 
      }
      else {
        for (let i = 0; i <originalData.length; i++) {
          originalData[i]["status_checkbox"] = false
        }
        for (let i = 0; i < filteredData; i++) {
          filteredData[i]["status_checkbox"] = false
        }
        setBookedAmount([]);
        setFilteredData([...filteredData]);
        setoriginal_data(originalData);
        setcheckboxAll(false);
      }
    }
    else {
      const setmaster = originalData.filter(data => data.bus_id === value.bus_id);
      value["status_checkbox"] = !value["status_checkbox"];
      setmaster["status_checkbox"] = !setmaster["status_checkbox"];
      const result = originalData.filter(data => data.status_checkbox === true);
      setBookedAmount(result);
      setFilteredData([...filteredData]);
      setoriginal_data(originalData);
    }
  };
  const onSelectChange = (tempRowKeys, tempRows) => {
    setSelectedRowKeys(tempRowKeys);
    setSelectedRows(tempRows);
    // กรณีเปลี่ยน tab และselect booked bus เพิ่ม
    setBookedData(tempRows);
    // console.log(selectedRowKeys, selectedRows);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // sortedInfo = sortedInfo || {};
  // filteredInfo = filteredInfo || {};

  return (
    <>
    {setcountJob(filteredData.length)}
    <Table
      // rowKey="asset_id"
      columns={columns}
      dataSource={filteredData}
      onChange={handleChange}
      // rowSelection={rowSelection}
      rowKey="license_plate"
      scroll={{ x: 3000 , y : 500}}
      components={VList? VList({
        height: "500",
        width: "3000",
        vid:"bus_table"
      }): null}
      pagination={false}
    />
    </>
  );
};

export default BusTable;
